// src/pages/platform/PlatformCreatePage.tsx
// Legacy route kept resolvable for old links/bookmarks. Platform creation now
// happens through PlatformCreateDialog (form-kit), opened from
// PlatformListPage's "+ New" — see docs/ux/14-forms.md. This route just
// sends people there.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const PlatformCreatePage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/platforms', { replace: true });
  }, [navigate]);
  return null;
};

export default PlatformCreatePage;
